import React, { useState } from 'react';
import { TabPanel, TabView } from 'primereact/tabview';
import { MyDashboardCA } from '../../utils/typeConstants';
import {MyDashboardCa} from '../../features/correctiveActions/myDashboardCa/myDashboardCa';
import { CaMangerTl } from '../../features/correctiveActions/managerTlViewSearch/CaMangerTlView'
import { caDetails } from '../../features/correctiveActions/type';

export const MyCorrectiveActionsAssignment = () => {
    const [activeIndex, setActiveIndex] = useState<number>(MyDashboardCA.Dashboard);
    const [selectedEmployee, setSelectedEmployee] = useState<caDetails | undefined>();
    const [via, setVia] = useState<string>('tab');

    return (
        <div>
            
            <div className="card shadow bg-body rounded mt-4 border-0">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            <TabView
                                activeIndex={activeIndex}
                                onTabChange={(e) => {
                                    setActiveIndex(e.index);
                                }}
                            >
                                <TabPanel header="Dashboard">
                                    <div className="card border-0 p-3 ps-0">
                                        <div className="card-body p-0">
                                           <MyDashboardCa fromPage = 'CaDashboard' setVia={setVia} setSelectedEmployee={setSelectedEmployee} setActiveIndex={setActiveIndex}/>
                                        </div>
                                    </div>
                                </TabPanel>
                                {activeIndex === MyDashboardCA.Acknowledged && <TabPanel header="Update">
                                    <div className="card border-0 p-3 ps-0">
                                        <div className="card-body p-0">
                                            <CaMangerTl setActiveIndex={setActiveIndex} type = {'ack'} getDetails via={via} selectedEmployee={selectedEmployee} view />
                                        </div>
                                    </div>
                                </TabPanel>}
                            </TabView>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
